import Routing from 'fos-router';

import routes from '@app/.cache/fos_js_routes.json';

Routing.setRoutingData(routes);
Routing.setHost(import.meta.env.VITE_APP_API_HOST!);
Routing.setScheme(import.meta.env.VITE_APP_API_SCHEME!);
export default Routing;
